<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="blendSupplierForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="blendSupplier" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                blendSupplierForm: () => import('../forms/BlendSupplierForm'),
                blendSupplier: () => import('../editViews/BlendSupplier'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Supplier Name', value: 'supplierName' },
                    { text: 'Supplier Member', value: 'supplierMemberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "supplierName", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                ],
                itemsField: 'blendSuppliers',
                editPageName: 'blendSupplier',
                apiMethod: 'BlendSuppliers',
                claimName: 'BlendSuppliers',
                formTitle: 'Blend Supplier',
                excelTitle: 'Blend Suppliers',
                hasEditPage: true,
            }
        },
    };
</script>
